/** Mirror-tracked ingested records per organization. */
import { apiGet } from '../client.js';
import type { MirrorRecord } from '../types.js';

/**
 * Records live on the tenant router, not the admin one, so this takes the
 * organization as a query parameter rather than a path segment. Platform
 * staff read any tenant: the membership check returns early for an internal
 * principal.
 */
export function listOrgRecords(
  organizationId: string,
  filters: { modelName?: string; collections?: string; limit?: number } = {},
): Promise<MirrorRecord[]> {
  const query: Record<string, string> = { organization_id: organizationId };
  if (filters.modelName) query.model_name = filters.modelName;
  if (filters.collections) query.collections = filters.collections;
  if (filters.limit) query.limit = String(filters.limit);
  return apiGet<MirrorRecord[]>('/api/v1/records', query);
}
